import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Result } from "src/app/models/ResultModel";
import { environment } from "src/environments/environment";
import { FreeSearchConfigVM, OpenSearchModel } from "../../admin/open-searches/model/open-search.model";

@Injectable({
    providedIn: 'root'
})
export class OpenSearchService {
    public baseurl = environment.apiUrl;
    private planApi = "api/opensearch";
    constructor(private http: HttpClient) { }

    getOpenSearch():Observable<Result<FreeSearchConfigVM>> {
        const url = this.baseurl + this.planApi;
        return this.http.get<Result<FreeSearchConfigVM>>(url);
    }

    getOpenSearchByFeatureName(featureName:string):Observable<Result<FreeSearchConfigVM>> {
        const url = this.baseurl + this.planApi+"/GetOpenSearchByFieldName"+'?fieldName='+featureName;
        return this.http.get<Result<FreeSearchConfigVM>>(url);
    }

    updateOpenSearch(openSearch:OpenSearchModel[]):Observable<Result<OpenSearchModel[]>> {
        const url = this.baseurl + this.planApi;
        return this.http.put<Result<OpenSearchModel[]>>(url,openSearch);
    }

     getIPAccessLogs():Observable<Result<any[]>> {
        const url = this.baseurl + this.planApi +"/"+"iplogs" ;
        return this.http.get<Result<any[]>>(url);
    }
     getFreeSearchPolicy():Observable<Result<any[]>> {
        const url = this.baseurl + this.planApi  +"/"+"freesearchpolicies";
        return this.http.get<Result<any[]>>(url);
    }
}